<template>
  <v-layout justify-center>

    <v-dialog v-model="dialog_status"
      class="dialog-container"
      persistent max-width="400px"
      @keydown.esc="close()">

      <v-card>

      <!-- title -->
        <v-card-title class="card-title">
          <span>{{ $t('change_password.change_password') }}</span>
        </v-card-title>

        <!-- text -->
        <v-card-text>
          <!-- password -->
          <v-form>

            <div class="input-field">
              <div class="input-label">
                <span>{{ $t('change_password.password') }}</span>
                <span class="required">*</span>
              </div>
              <v-text-field
                outlined flat
                v-model.lazy="password"
                type="password"
                @change="resetError"
                @blur="$v.password.$touch()"
                :rules="passwordErrors">
              </v-text-field>
            </div>

            <!-- password_re -->
            <div class="input-field">
              <div class="input-label">
                <span>{{ $t('change_password.password_re') }}</span>
                <span class="required">*</span>
              </div>
              <v-text-field
                outlined flat
                v-model.lazy="password_re"
                type="password"
                @change="resetError"
                @blur="$v.password_re.$touch()"
                :rules="passwordReErrors">
              </v-text-field>
            </div>

          </v-form>

          <!-- error message -->
          <div class="message-error" v-if="error">
            {{ $t('change_password.try_again') }}
          </div>
        </v-card-text>

        <!-- actions -->
        <v-card-actions class="actions">
          <div class="buttons">
            <v-btn small text @click="close()">
              {{ $t('change_password.close') }}
            </v-btn>
            <v-btn small depressed color="primary"
              :disabled="!password.length||!password_re.length"
              @click="changePassword()">
              {{ $t('change_password.confirm') }}
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>

    </v-dialog>
  </v-layout>
</template>

<script>
import { required, minLength, maxLength, sameAs } from 'vuelidate/lib/validators'

export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      password: "",
      password_re: "",

      error: false,
    }
  },

  computed: {
    dialog_status: {
      get: function(value) {
        return this.dialog
      },
      set: function(value) {
        if (!value) { this.close() }
      },
    },

    passwordErrors() {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.required && errors.push(this.$t('register.required'))
      !this.$v.password.goodPassword && errors.push(this.$t('register.password_not_valid'))
      return errors
    },

    passwordReErrors() {
      const errors = []
      if (!this.$v.password_re.$dirty) return errors
      !this.$v.password_re.required && errors.push(this.$t('register.required'))
      !this.$v.password_re.sameAs && errors.push(this.$t('register.password_not_same'))
      return errors
    },
  },

  validations: {
    password: {
      required,
      goodPassword(password) {
        return /[a-z]/.test(password) &&
        /[0-9]/.test(password) &&
        password.length >= 8 && password.length < 31
      }
    },
    password_re: {
      required,
      sameAs: sameAs('password')
    },
  },

  created() {
    this.password = ""
    this.password_re = ""
  },

  methods: {
    close() {
      this.resetError()
      this.$emit('update:dialog', false)
    },

    resetError() {
      if (this.error) {
        this.error = false
      }
    },

    async changePassword() {
      await this.$v.$touch()
      if (!this.$v.$anyError) {
        try {
          await this.$store.dispatch('user/updateUserInfo', {
            password: this.password
          })
        } catch(e) {
          this.error = true
        }
        finally {
          if (!this.error) {
            this.success = true
            this.password = ""
            this.password_re = ""
            this.$analytics.logEvent('click', { name: 'account_btn_changePassword' })
            this.close()
          }
        }
      }
    },
  }
}
</script>

<style scoped>
  .actions {
    display: flex;
    flex-direction: column;
  }

  .buttons {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }

  .input-field {
    display: grid;
    grid-template-columns: 130px auto;
  }

  .input-label {
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    padding-right: 22px;
    padding-top: 8px;
  }

  .required {
    color: #F65058;
    padding-left: 3px;
  }

  .message-error {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
</style>


// WEBPACK FOOTER //
// src/components/modal/account/ChangePassword.vue